
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import MenuDeleteSubCategory from "./menu-delete-sub-category.vue";
import menuMoveToSubcategory from "./menu-move-to-subcategory.vue";
export default {
  components: { menuMoveToSubcategory, MenuDeleteSubCategory },
  name: "MenuCreateCategory",
  props: {
    dialog: false,
    categoryProp: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      loading: false,
      category: {},
      hasSubCategory: false,
      CATEGORY_ITEM: {
        category_name: "",
        category_description: "",
        whatsapp_enabled: false,
        subcategories: []
      },
      SUB_CATEGORY_ITEM: {
        subcategory_name: "",
        subcategory_description: ""
      },
      valid: false,
      showMoveToSubCategory: false,
      selectedSubCategoryName: null,
      selectedSubCategory: null,
      showDeleteSubCategory: false,
      SubCategoryDeletionInfo: null,
      subCategoriesForDeletion: []
    };
  },
  computed: {
    ...mapGetters("menu", ["getCategoryObj"]),
    ...mapState("menu", ["categories", "menuUploadList"]),
    ...mapGetters("reciever", ["isWhatsappAdded"]),

    isNew() {
      return !(this.categoryProp && this.categoryProp.id);
    },
    exceedsCount() {
      return (
        this.categories.filter((category) => category.whatsapp_enabled)
          .length >= 10
      );
    },
    getItemCount() {
      return this.menuUploadList?.filter((item) => {
        return item.category_id === this.categoryProp.id;
      });
    }
  },
  watch: {},
  beforeMount() {
    if (this.isNew) {
      this.CATEGORY_ITEM.subcategories.push(
        JSON.parse(JSON.stringify(this.SUB_CATEGORY_ITEM))
      );
    }
    this.initCategory();
    if (!this.isNew && this.category?.subcategories?.length > 0) {
      this.hasSubCategory = true;
    }
  },
  mounted() {
    if (!this.isNew) {
      this.validate();
    }
  },
  methods: {
    ...mapActions("menu", [
      "createCategory",
      "updateCategory",
      "getCategories"
    ]),
    ...mapMutations("menu", [
      "SET_MENU_UPLOAD_LIST",
      "SET_MENU_UPLOAD_DRAG_SELECTION"
    ]),
    validate() {
      this.valid = this.$refs.form.validate();
    },
    initCategory() {
      this.category = this.isNew
        ? JSON.parse(JSON.stringify(this.CATEGORY_ITEM))
        : JSON.parse(JSON.stringify(this.getCategoryObj(this.categoryProp.id)));
    },
    hasSubCategoryChange() {
      if (
        (this.hasSubCategory && !this.category?.subcategories) ||
        (this.hasSubCategory && this.category?.subcategories?.length == 0)
      ) {
        this.addNewSubCategory();
      }
      this.validate();
    },
    addNewSubCategory() {
      this.category = this.category || {};
      this.category.subcategories = this.category.subcategories || [];
      this.category.subcategories.push(
        JSON.parse(JSON.stringify(this.SUB_CATEGORY_ITEM))
      );
      this.validate();
    },
    handleSubCategoryInfoSubmit(subCategoryName) {
      this.selectedSubCategoryName = subCategoryName;
      this.handleUpdateCategory();
    },
    handleSubmit() {
      if (this.isNew) {
        this.handleCreateCategory();
      } else {
        let isSubcategoryPresent = !!this.categoryProp?.subAttributes?.length;
        let items = this.menuUploadList?.filter((item) => {
          return item.category_id === this.categoryProp.id;
        });
        if (
          !isSubcategoryPresent &&
          this.hasSubCategory &&
          this.category?.subcategories?.length &&
          items &&
          items.length > 0
        ) {
          this.showMoveToSubCategory = true;
          return;
        }
        this.handleUpdateCategory();
      }
    },
    handleCreateCategory() {
      this.loading = true;
      // this.category.zomato_subcategories_attributes = this.category.subcategories;
      let payload = JSON.parse(JSON.stringify(this.category));
      if (!this.hasSubCategory) delete payload.subcategories;
      this.createCategory({ category: payload })
        .then((res) => {
          this.getCategories(true);
          this.$nuxt.$emit("show-toast", {
            text: "Item created successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("close-dialog");
          this.loading = false;
          this.initCategory();
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
          this.loading = false;
        });
    },
    handleUpdateCategory() {
      this.loading = true;
      let isSubcategoryPresent = !!this.categoryProp?.subAttributes?.length;
      let payload = JSON.parse(JSON.stringify(this.category));
      if (!this.hasSubCategory) delete payload.subcategories;
      this.updateCategory(payload)
        .then((res) => {
          this.getCategories(true);
          this.$nuxt.$emit("show-toast", {
            text: "Item updated successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          // Extract remaining subcategory IDs
          let remainingSubcategoryIds =
            res?.subcategories?.map((subcategory) => subcategory.id) || [];

          // Check if all deleted subcategory IDs are not in the remaining subcategories --> to verify all the deleted subcategories are actually deleted
          let allDeleted = this.subCategoriesForDeletion.every(
            (deletion) => !remainingSubcategoryIds.includes(deletion.id)
          );
          if (
            this.SubCategoryDeletionInfo &&
            allDeleted &&
            this.subCategoriesForDeletion.length
          ) {
            const subCategoriesDeleted = [];
            this.subCategoriesForDeletion.forEach((subCategory) => {
              if (subCategory.selectedOption === "delete") {
                const updatedMenuUploadList = this.menuUploadList.filter(
                  (item) => {
                    return item?.sub_category_id !== subCategory.id;
                  }
                );
                this.SET_MENU_UPLOAD_LIST(updatedMenuUploadList);
                this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
                this.$nuxt.$emit("clear-menu-upload-item-selection");
              }
              this.$emit("subcategory-deleted", this.subCategoriesForDeletion);
            });
          }
          if (
            !this.hasSubCategory &&
            isSubcategoryPresent &&
            (!res?.subcategories || !res?.subcategories.length)
          ) {
            this.$emit("move-to-category", this.subCategoriesForDeletion);
          }

          if (this.selectedSubCategoryName) {
            let selectedSubCategory = res?.subcategories?.find(
              (subcategory) =>
                subcategory.subcategory_name === this.selectedSubCategoryName
            );
            let selectedSubCategoryId = selectedSubCategory.id;

            this.$emit("move-to-subcategory", selectedSubCategoryId);
          }
          this.$emit("close-dialog");
          this.initCategory();
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
          this.loading = false;
        });
    },

    deleteSubCategory(subCategoryId, index) {
      // this.selectedSubCategory = {};
      if (subCategoryId) {
        if (this.menuUploadList.length) {
          this.selectedSubCategory = this.categoryProp?.subAttributes.find(
            (subCategory) => subCategory.id === subCategoryId
          );

          let itemLinkedToSubCategory = this.menuUploadList?.filter((item) => {
            return item.sub_category_id === this.selectedSubCategory?.id;
          });

          if (itemLinkedToSubCategory.length) {
            this.showDeleteSubCategory = true;
          } else {
            this.category.subcategories = this.category.subcategories.filter(
              (subCategory) => subCategory.id !== subCategoryId
            );
            const subCategorySelectedForDeletion = this.selectedSubCategory;
            subCategorySelectedForDeletion.selectedOption = "delete";
            this.subCategoriesForDeletion.push(subCategorySelectedForDeletion);
            if (!this.category.subcategories.length) {
              this.hasSubCategory = false;
            }
          }
        } else {
          this.category.subcategories.splice(index, 1);
        }
      }
    },
    handleDeleteSubCategorySubmission(data) {
      this.showDeleteSubCategory = false;
      this.category.subcategories = this.category.subcategories.filter(
        (subCategory) => subCategory.id !== this.selectedSubCategory.id
      );
      const subCategorySelectedForDeletion = this.selectedSubCategory;
      subCategorySelectedForDeletion.selectedOption = data.selectedOption;
      subCategorySelectedForDeletion.destinationCategory =
        data.selectedCategory;
      this.subCategoriesForDeletion.push(subCategorySelectedForDeletion);
      if (!this.category.subcategories.length) {
        this.hasSubCategory = false;
      }
      this.SubCategoryDeletionInfo = data;
    }
  }
};
